<div *ngIf="viewType==='upload-box'" class="upload-box" (click)="trigger(file)" >
  <div data-test="upload-photo-box" class="content">
    <fa-icon [icon]="icons.upload"></fa-icon>
    <strong>{{title || 'Upload photo'}}</strong>
    <p>Click on the box to upload file from your computer.</p>
  </div>
</div>
<div *ngIf="viewType==='upload-more'">
  <h6 data-test="upload-more-handler" (click)="trigger(file)" class="cur-pnt"><b>
    <span class="me-2"><fa-icon [icon]="icons.upload"></fa-icon></span>
    <span>Upload more</span>
  </b></h6>
</div>
<div class="form-input-file" *ngIf="viewType==='upload-input'">
  <label [for]="id" class="form-label">{{label}}</label>
  <input data-test="upload-input" #inputFile (change)="onFileChange($event, inputFile)" class="form-control" type="file"
     [accept]='accept' [id]="id" [multiple]="multiple" [disabled]="disabled" [required]="required">
  <p class="caption-text">{{inputCaption}}</p>
  <ng-container *ngIf="uploadedFile">
    <p class="caption-text" *ngIf="uploadedFile.status==='progress'">
      <span class="me-2">Uploading...</span>
      <fa-icon [spin]="true" [icon]="icons.spinner" ></fa-icon></p>
  </ng-container>
</div>
<input type="file" data-test="upload-input" (change)="onFileChange($event, null)" hidden #file [accept]="accept" [multiple]="true" />
